const scene = "questions/";
export const UPDATE_QUESTIONS = `${scene}UPDATE_QUESTIONS`;
export const UPDATE_ELECTIVE_SUBJECT = `${scene}UPDATE_ELECTIVE_SUBJECT`;